import React from 'react';
import {CgSandClock} from "react-icons/cg";
import {FaRegCheckCircle} from "react-icons/fa";
import {FaRegCircleXmark, FaHouse, FaChalkboardUser, FaComputer} from "react-icons/fa6";
import {TbRestore, TbExclamationCircle} from "react-icons/tb";
import {FcApprove, FcDisapprove} from "react-icons/fc";
import {RiVipFill, RiImage2Fill} from "react-icons/ri";
import {IoTicketSharp} from "react-icons/io5";
import {MdLocalPostOffice} from "react-icons/md";

const OpsIconStatus = ({status = "pending"}) => {
    const getIcon = () => {
        switch (status) {
            case "pending":
                return <CgSandClock color="var(--color-orange)" className="ops-icon-sm"/>;
            case "completed":
                return <FaRegCheckCircle color="var(--color-green)" className="ops-icon-sm"/>;
            case "failed":
                return <TbExclamationCircle color="var(--color-red)" className="ops-icon-sm"/>;
            case "restored":
                return <TbRestore color="var(--color-orange)" className="ops-icon-sm"/>;
            case "activated":
                return <FcApprove className="ops-icon-sm-2"/>;
            case "notactivated":
                return <FcDisapprove className="ops-icon-sm-2"/>;
            case "deleted":
                return <FaRegCircleXmark color="var(--color-g-2)" className="ops-icon-sm"/>;
            case "private":
                return <RiVipFill color="var(--color-g-2)" className="ops-icon-sm"/>;
            case "ticket":
                return <IoTicketSharp color="var(--color-g-2)" className="ops-icon-sm"/>;
            case "poster":
                return <RiImage2Fill color="var(--color-g-2)" className="ops-icon-sm"/>;
            case "standard":
                return <MdLocalPostOffice color="var(--color-orange)" className="ops-icon-sm"/>;
            case "pickup":
                return <FaHouse color="var(--color-p-400)" className="ops-icon-sm"/>;
            case "customer":
                return <FaChalkboardUser color="var(--color-g-2)" className="ops-icon-sm"/>;
            case "system":
                return <FaComputer color="var(--color-g-2)" className="ops-icon-sm"/>;
            default:
                return <div/>;
        }
    };

    return getIcon();
};

export default OpsIconStatus;